module.exports = __webpack_public_path__ + "img/travel2.40836d66.jpg";